<form class="grid gap-6 mb-5" [formGroup]="form">
  <div formGroupName="address">
    <xena-select formControlName="countryName" label="Country" i18n-label="@@createFiscal_step1_country" hoist>
      <xena-menu-item *ngFor="let c of countries" [value]="c.abbreviation">{{ c.translatedName }}</xena-menu-item>
    </xena-select>
  </div>
  <div class="grid grid-cols-3 gap-6">
    <xena-input *ngIf="form.get('address.countryName').value !== 'DK'"
      formControlName="orgNumber"
      class="col-span-2"
      label="CVR/ORG number" i18n-label="@@createFiscal_step1_cvrorgnumber">
      <span slot="error-text" *ngIf="form.get('orgNumber').touched && form.get('orgNumber').invalid" i18n="@@createFiscal_step1_cvrorgnumber_Required">An organization number is required</span>
    </xena-input>
    <xena-autocomplete
      idProperty="cVRNumber"
      valueLabelProperty="cVRNumber"
      [listLabelProperty]="companyLabel"
      [datasource]="companiesDatasource"
      [hidden]="form.get('address.countryName').value !== 'DK'"
      formControlName="danishCompany"
      class="col-span-2"
      debounce="300" show-initial-no-result="false"
      label="CVR/ORG number" i18n-label="@@createFiscal_step1_cvrorgnumber"
      no-result-text="No results" i18n-no-result-text="@@createFiscal_step1_orgNumber_noResult" hoist>
      <span slot="error-text" *ngIf="form.get('orgNumber').touched && form.get('orgNumber').invalid" i18n="@@createFiscal_step1_cvrorgnumber_Required">An organization number is required</span>
    </xena-autocomplete>
    <xena-checkbox
      formControlName="registeredForVat"
      class="mt-6"
      i18n="@@createFiscal_step1_vatregistered">VAT registered</xena-checkbox>
  </div>
  <div formGroupName="address">
    <xena-input
      formControlName="name"
      label="Company name" i18n-label="@@createFiscal_step1_companyName">
      <span slot="error-text" *ngIf="form.get('address.name').touched && form.get('address.name').invalid" i18n="@@createFiscal_step1_companyName_Required">A company name is required</span>
    </xena-input>
  </div>
  <div class="grid grid-cols-3 gap-4" formGroupName="address">
    <xena-input formControlName="street"class="col-span-3" label="Address" i18n-label="@@createFiscal_step1_address" placeholder="Street" i18n-placeholder="@@createFiscal_step1_street"></xena-input>
    <xena-input formControlName="placeName"  placeholder="Place name" class="col-span-3" i18n-placeholder="@@createFiscal_step1_PlaceName"></xena-input>
    <xena-input formControlName="zip"  placeholder="Zip code" i18n-placeholder="@@createFiscal_step1_ZipCode"></xena-input>
    <xena-input formControlName="city" placeholder="City" class="col-span-2" i18n-placeholder="@@createFiscal_step1_City"></xena-input>
  </div>
  <div class="grid grid-cols-2 gap-6">
    <xena-input
      formControlName="phone"
      type="tel"
      label="Phone number" i18n-label="@@createFiscal_step1_PhoneNumber">
      <span slot="error-text" *ngIf="form.get('phone').touched && form.get('phone').invalid" i18n="@@createFiscal_step1_PhoneNumber_Required">A phone number is required</span>
    </xena-input>
    <xena-input
      formControlName="email"
      type="email"
      label="Email address" i18n-label="@@createFiscal_step1_EmailAddress">
      <span slot="error-text" *ngIf="form.get('email').touched && form.get('email').invalid" i18n="@@createFiscal_step1_EmailAddress_Required">A valid email address is required</span>
    </xena-input>
  </div>
</form>
